import {observer} from 'mobx-react';
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import {GapFillingEditStore} from '../GapFillingEditStore';

@observer
export class GapFillingTextArea extends React.Component<{ store: GapFillingEditStore }> {
  render() {
    const store = this.props.store;

    return (
      <TextareaAutosize className="form-control"
                        value={store.serialized.value}
                        onChange={store.serialized.onChangeHandler}>
      </TextareaAutosize>
    );
  }
}
